import { FC, FocusEventHandler, forwardRef, Ref, useState } from "react";
import { FormValidationResult } from "../../../../form/formValidation";
import { FieldGroup } from "../../../../form/FieldGroup";
import { Icon, InputText } from "@goodfill/ui-components";
import { Link } from "../../../../ui-components/Link/Link";

const parseSymbols = (value: string) =>
  value
    .split(",")
    .map((s) => s.trim())
    .filter((s) => Boolean(s));

interface StockSymbolsFieldProps {
  label: string;
  symbols: string[];
  onChangeState: (symbols: string[]) => void;
  validation: FormValidationResult;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  ref?: Ref<HTMLInputElement>;
  disabled?: boolean;
}

export const StockSymbolsField: FC<StockSymbolsFieldProps> = forwardRef(
  ({ label, symbols, onChangeState, validation, onBlur }, ref) => {
    const [value, setValue] = useState<string>("");
    const addEnabled = Boolean(value);

    const onInputValueChange = (newValue: string) => setValue(newValue.toUpperCase());
    const setSymbols = (newSymbols: string[]) => onChangeState(newSymbols);
    const addSymbols = (newSymbols: string[]) => setSymbols([...new Set([...symbols, ...newSymbols])]);
    const onAddClick = () => {
      addEnabled && addSymbols(parseSymbols(value));
      setValue("");
    };

    const removeSymbol = (symbol: string) => () => setSymbols(symbols.filter((sym) => sym !== symbol));

    return (
      <FieldGroup label={label} validation={validation} className="w-80-sm w-full-after-md" fill>
        <InputText
          value={value}
          setValue={onInputValueChange}
          placeholder={"Type symbols, separated by comma"}
          onBlur={onBlur}
          ref={ref}
          className="rounded-[6px] shadow-none border border-color-gray"
        />
        <Link disabled={!addEnabled} onClick={onAddClick}>
          +&nbsp;Add
        </Link>
        <ul>
          {symbols?.map((symbol, index) => (
            <li
              key={index}
              style={{
                margin: "0 .5em .5em",
              }}
            >
              <div className="flex border-b border-neutral-110 justify-between pb-1">
                <span>{symbol}</span>
                <Icon name={"x"} size={20} onClick={removeSymbol(symbol)} />
              </div>
            </li>
          ))}
        </ul>
      </FieldGroup>
    );
  },
);
